// React
import React, { Fragment, useEffect } from 'react'
import PropTypes from 'prop-types'

// Components
import Spacer from 'ui/blocks/Spacer'
import { Error } from './styles'
import P from 'ui/elements/P'

// Libraries
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle as fasExclamationTriangle } from '@fortawesome/pro-regular-svg-icons'

// Hooks
import { useCart } from 'shop-components/utils/useCart'
import { useOrm } from 'shared/utils/useOrm'
import { useTranslation } from 'shared/utils/useTranslation'
import { useSettings } from 'shared/utils/useSettings'

export const Errors = ({ onError }) => {
  let errorText
  let cannotCheckout = false

  const { cart, isOverdue, isEmpty } = useCart()

  const useAvailability = useSettings('store.use_availability')

  const unavailableLines = useOrm('lines', (lines) => {
    return lines
      .getAll({
        id: cart?.lines,
        can_checkout: false
      })
      .filter((line) => line.line_type !== 'delivery_rate')
  })

  const { t } = useTranslation('user')

  const hasDates = !!(cart?.starts_at && cart?.stops_at)

  if (hasDates && cannotCheckout) {
    errorText = t('user.store.not_all_products_available')
  }

  if (!hasDates) {
    errorText = t('user.store.select_a_period', 'Select a rental period')
  }

  if (isOverdue) {
    errorText = t('user.checkout.dates_in_past')
  }

  if (useAvailability) {
    cannotCheckout = unavailableLines.size() > 0
  }

  useEffect(() => {
    if (errorText || isEmpty) {
      onError(errorText || true)
    } else {
      onError(null)
    }
  }, [errorText, isEmpty])

  if (!errorText) return null

  return (
    <Fragment>
      <Error>
        <FontAwesomeIcon icon={fasExclamationTriangle} />
        <P>{errorText}</P>
      </Error>
      <Spacer />
    </Fragment>
  )
}

Errors.displayName = 'Errors'

Errors.propTypes = {
  onError: PropTypes.func
}
